// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"font-size-10_wrapper__pmvsT","inner":"font-size-10_inner__y3DQ4"};